import { IVideoPlayerComponent } from "front-end/components/video-box/factories/video-player.component";
import { VideoPlayerComponentBase } from "front-end/components/video-box/factories/video-player.component.base";

export class YoutubePlayerComponent extends VideoPlayerComponentBase implements IVideoPlayerComponent {
    private _internalPlayer: YT.Player = null;

    private _loopVideo: boolean;

    public play(): void {
        this._internalPlayer.playVideo();
    }

    public pause(): void {
        this._internalPlayer.pauseVideo();
    }

    public loop(state: boolean): void {
        this._loopVideo = state;
    }

    public mute(): void {
        this._internalPlayer.mute();
    }

    public destroy(): void {
        this._internalPlayer.destroy();
    }

    private bindEvents(): void {
        this._internalPlayer.addEventListener("onStateChange", (event: YT.OnStateChangeEvent) => {
            this.setState(event.data);
        });
    }

    public init(internalPlayer: YT.Player): void {
        this._internalPlayer = internalPlayer;
        this.bindEvents();
    }

    private setState(state: YT.PlayerState): void {
        const isPlaying = state === YT.PlayerState.PLAYING;
        this._isPlaying.next(isPlaying);

        if(this._loopVideo) {
            if (state === YT.PlayerState.ENDED) {
                this.play();
            }
        }
    }
}
